import { render, staticRenderFns } from "./_uid.vue?vue&type=template&id=204ba8b2&"
import script from "./_uid.vue?vue&type=script&lang=js&"
export * from "./_uid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports